/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'

import {
  BrowserRouter as Router,
  Switch
} from 'react-router-dom'

import Footer from '../screens/base/Footer'
import Navbar from '../screens/base/Navbar'
import { GET_FOLDER } from '../queries'
import AppRoute from '../components/AppRoute'

import { useThemeData } from '../context/ThemeDataContext'
import { useCartData } from '../context/CartProvider'
import SideNavbar from '../screens/base/SideNavbar'

import Container from '@mui/material/Container';

//import HomeEquestrianPhotoService from '../screens/homeequestrianphotoservice'

function CustomRouter (props) {
  const { primary_color_2, background_color_6, font_family, nav_position } = useThemeData().themeData.site.theme
  const site_id = useThemeData().themeData.site.site_id
  const { category_id } = useThemeData().categoryData
  const { photographerType, newRoute } = useThemeData()
  const { ShowCart } = useCartData().cart.cartDisplay
  const [folder_id, setFolderID] = useState(0)
  const [user_id, setUserId] = useState('')
  const [product_color] = useState('Kleur')
  const [keuzeset_id, setKeuzesetID] = useState(0)

  const [albumList, { error: errorAlbum, loading: loadingAlbum, data: dataAlbum }] =
    useLazyQuery(GET_FOLDER, {
      variables: {
        site_id: site_id,
        type: 'school',
        folder_naam: 'Upload'
      }
    })

  useEffect(() => {
    if (site_id !== '' && photographerType === 'printservice') {
      albumList()
      if (!loadingAlbum && !errorAlbum) {
        if (dataAlbum) {
          setUserId(dataAlbum.albumList.user_id)
          setFolderID(dataAlbum.albumList.folder_id)
          setKeuzesetID(dataAlbum.albumList.keuzeset_id)
        }
      }
    }
  }, [dataAlbum, errorAlbum, loadingAlbum, albumList, photographerType, site_id])

  return (
    <Router>
      <div id="app_root" className="app" style={{
        display: `${nav_position === 'left' ? 'flex' : 'block'}`,
        fontFamily: `${font_family}`,
        color: `${primary_color_2}`,
        backgroundColor: `${background_color_6}`
      }}
            onClick={() => ShowCart(false)}
          // TODO: turn this back on (Commented it out to test cart features (it keeps closing the cart if you click anywhere on the screen))
      >
        {nav_position === 'left' ?
        <SideNavbar/>
        :
        <Navbar/>
        }
        {/* <div className="container-fluid no-margin-right bottom-page top-page container-page"> */}
        <Container maxWidth="xl" sx={{ mt: "4rem" }}>
          <Switch>
            {newRoute.map((route) => (
              <AppRoute
                key={route.path}
                path={route.path}
                exact={route.exact}
                component={route.component}
                isPrivate={route.isPrivate}
                folder_id={folder_id}
                user_id={user_id}
                keuzeset_id={keuzeset_id}
                category_id={category_id}
                location={props.location}
                product_color={product_color}
              />
            ))}
          </Switch>
          </Container>
        <Footer/>
      </div>
    </Router>
  )

}

export default React.memo(CustomRouter);

